import { createTheme } from '@mantine/core'

export const theme = createTheme({
  primaryColor: 'blue',
  fontSmoothing: true,
  fontFamily: 'Nunito, sans-serif',
})
